// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3p5-I","location":"Header_location__vcI0h"};